module.exports = __webpack_public_path__ + "static/media/jihao.a59374c2.png";